import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedServicesService {

  private subject = new Subject<any>();

  sendClickEvent(){
    this.subject.next();
  }

  getEvent(): Observable<any>{
    return this.subject.asObservable();
  }

  constructor() { }
}
